export default __webpack_public_path__ + "static/media/ensaladapalta.a77025af.png";